import { type AppContext, type Component, type ComponentInternalInstance, getCurrentInstance, nextTick, render } from 'vue'

import { type PopWindowInfoProps, type PopWindowProps } from './interface'
import { ElScrollbar } from 'element-plus'

let appContextConst: AppContext | undefined
let popWindowList: Array<any> = []
const getBody = (): Element => {
  return document.querySelector('body') as HTMLBodyElement
}
/**
 * 显示弹出窗口
 *
 * 此函数用于创建并显示一个弹出窗口，支持自定义样式和内容通过参数传递
 * 可以选择附加到特定的父元素，并且在渲染后会将自身添加到弹出窗口列表中
 *
 * @param props 弹出窗口的属性，包括位置、尺寸等样式属性以及附加属性
 * @param component 可选参数，用于指定弹出窗口内渲染的自定义组件类型,如果props中传了render函数，则无效
 * @param componentProps 可选参数，传递给自定义组件的属性
 */
export const showPopWindow = (props: PopWindowProps, component?: Component, componentProps?: any) => {
  const op = {
    left: '0',
    top: '0',
    width: '100px',
    height: '100px',
    position: 'absolute',
    id: 'popwindow_' + Math.ceil(Math.random() * 1000000),
    animate: true,
    animateInClass: 'animate__animated animate__faster animate__fadeIn',
    animateOutClass: 'animate__animated animate__faster animate__fadeOut'
  }
  const option: PopWindowProps = Object.assign(op, props)
  const close = () => {
    closePopWindowById(option.id)
  }

  // 相同的id只会存在一个
  closePopWindowById(option.id)
  let animateClass = option.animate ? option.animateInClass : ''

  const vm = (
    <div
      class={'popWindow ' + animateClass}
      style={{ width: option.width, height: option.height, left: option.left, top: option.top, position: option.position }}>
      <ElScrollbar>
        {props.render ? props.render({ close, option }) : <component is={component} {...componentProps} onClose={() => close()}></component>}
      </ElScrollbar>
    </div>
  )
  vm.appContext = appContextConst
  // debugger
  // if (vm.children?.length) {
  //   vm.children[0].appContext = appContextConst
  // }
  const container = document.createElement('div')
  container.id = 'popwindow_' + Math.ceil(Math.random() * 1000000)

  let parentEl = getBody()
  if (props.appendParent) {
    parentEl = document.getElementById(props.appendParent)
  }
  parentEl.appendChild(container)
  render(vm, container)

  nextTick(() => {
    const popWindowInfo = { id: option.id, tag: option.tag, node: container, option }
    popWindowList.push(popWindowInfo)
  })
  return { id: option.id, close }
}

const removePopWindow = (popWindowInfo: PopWindowInfoProps) => {
  if (!popWindowInfo) return
  const { option, node } = popWindowInfo
  option.onClose?.()
  if (option.animate) {
    const popWindowNode = node.querySelector('.popWindow')
    popWindowNode.className = 'popWindow ' + option.animateOutClass
    popWindowNode.addEventListener('animationend', () => {
      render(null, node)
      node.remove()
      popWindowList.splice(popWindowList.indexOf(popWindowInfo), 1)
    })
  } else {
    render(null, node)
    node.remove()
    popWindowList.splice(popWindowList.indexOf(popWindowInfo), 1)
  }
}
export const closePopWindowById = (id: string) => {
  const popWindowItem = popWindowList.find((item) => item.id === id)
  if (popWindowItem) {
    removePopWindow(popWindowItem)
  }
}

export const closePopWindowByTag = (tag: string) => {
  const popWindows = popWindowList.filter((item) => item.tag === tag)
  popWindows.forEach((item) => removePopWindow(item))
}

export const getAllPopWindows = () => {
  return popWindowList
}

export const initPopWindow = (ctx?: ComponentInternalInstance) => {
  const { appContext } = ctx || getCurrentInstance() || {}
  appContextConst = appContext

  return { showPopWindow }
}
